/**
 * @file PlayerInfoBanner.tsx
 * @description
 * Component for the banner displayed at the top of pages when the user is logged in.
 * Shows the player's name and provides a logout button.
 *
 * @dependencies
 * - react: Standard React library.
 * - react-router-dom: For navigation after logout.
 * - ../contexts/AuthContext: To get player name and logout function.
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const PlayerInfoBanner: React.FC = () => {
  const { playerName, logout } = useAuth();
  const navigate = useNavigate();

  // Don't render the banner if player name is not available (implies not authenticated)
  if (!playerName) {
    return null;
  }

  const handleLogout = () => {
      console.log(`Player ${playerName} logging out.`);
      logout(); // Call the logout function from AuthContext
      navigate('/login', { replace: true }); // Redirect to login page after logout
  };

  const handleGoToLobby = () => {
    navigate('/lobby');
  };

  // Basic inline styles for the banner - replace with CSS classes later
  const bannerStyle: React.CSSProperties = {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '10px 20px',
      backgroundColor: '#f0f0f0', // Light grey background
      borderBottom: '1px solid #ccc',
      fontSize: '0.9rem',
      color: '#333',
  };

  const welcomeStyle: React.CSSProperties = {
      fontWeight: 'bold',
  };

   // Basic inline styles for the logout button
   const logoutButtonStyle: React.CSSProperties = {
        padding: '5px 10px',
        fontSize: '0.8rem',
        backgroundColor: '#e0e0e0', // Slightly darker grey for button
        border: '1px solid #bbb',
        borderRadius: '4px',
        cursor: 'pointer',
   };

   const lobbyButtonStyle: React.CSSProperties = {
        padding: '5px 10px',
        fontSize: '0.8rem',
        backgroundColor: '#e0e0e0', // Slightly darker grey for button
        border: '1px solid #bbb',
        borderRadius: '4px',
        cursor: 'pointer',
   };


  return (
    <div style={bannerStyle} role="banner">
      <span style={welcomeStyle}>Welcome, {playerName}!</span>
      <button style={lobbyButtonStyle} onClick={handleGoToLobby}>Lobby</button>
      <button style={logoutButtonStyle} onClick={handleLogout}>Logout</button>
    </div>
  );
};

export default PlayerInfoBanner;